import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'login-page';
export const useLoginPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);
export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'Email или пароль неверны',
      user_is_blocked: 'Учетная запись заблокирована',
    },
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'Email or password is incorrect',
      user_is_blocked: 'User account is blocked',
    },
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'El correo electrónico o la contraseña son incorrectos',
      user_is_blocked: 'La cuenta de usuario está bloqueada',
    },
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'E-mail ou senha incorretos',
      user_is_blocked: 'A conta de usuário está bloqueada',
    },
  },
}) : {}) as Record<string, unknown>;
export const LoginPageI18n = {
  ruRu, en, esEs, ptBr,
};
